// extracted by mini-css-extract-plugin
export var page = "Page-module--page--24e03";
export var page__body = "Page-module--page__body--2ab2f";
export var page__open = "Page-module--page__open--723a4";
export var page__open__inner = "Page-module--page__open__inner--224f4";
export var page__title = "Page-module--page__title--5d268";